import { MediaDragDropUploadForm } from "fleet/view/media-library/media-upload-form";
import { connect } from "react-redux";
import { addErrorMessageAction } from "redux-store/messages";
import { uploadUserContentToS3Action } from "redux-store/user-contents/actions";

function mapStateToProps(state) {
  const { pages } = state;
  return {
    hasUploadError: pages.contentGroupForm.hasUploadError,
    isUploading: pages.contentGroupForm.isUploading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (payload) => {
      dispatch(uploadUserContentToS3Action(payload, "Media uploaded!"));
    },
    onError: (message) => {
      dispatch(addErrorMessageAction(message));
    },
  };
}

const ConnectedMediaUploadForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MediaDragDropUploadForm);

export { ConnectedMediaUploadForm };
